import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Avatar, Icon, Tooltip } from '@kontentino/ui';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import Link from 'components/shared/Link';
import OldApp from 'config/oldApp';
import { useCommentsSummary } from 'app/modules/posts/modules/post/components/postCommunication/comments/hooks/useCommentsSummary';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
const CommentsClientAssignedUsers: FC = () => {
  const { t } = useTranslation();
  const { data } = useCommentsSummary();

  const clients =
    data?.assignedUsers?.filter((user) => user.role === 'client') ?? [];

  if (clients.length === 0) {
    return null;
  }

  return (
    <Tooltip
      interactive
      className="!tw-border-grayscale-20 !tw-bg-white !tw-p-2 tw-shadow-xl"
      appendTo={document.body}
      content={
        <ul
          data-name="comments_client-assigned-users"
          className="tw-relative tw-flex tw-max-h-[300px] tw-min-w-[12rem] tw-flex-col tw-gap-2 tw-overflow-y-auto tw-overflow-x-hidden tw-px-2"
        >
          {clients.map((user) => (
            <li
              key={user.id}
              className="tw-flex tw-h-8 tw-shrink-0 tw-items-center"
            >
              <Avatar
                src={user.avatar?.src || undefined}
                size={20}
                name={`${user.name} ${user.surname}`}
                className="tw-mr-2"
              />
              <span className="tw-break-all tw-text-md tw-font-medium tw-text-grayscale-180">
                {`${user.name} ${user.surname}`}
              </span>
            </li>
          ))}
          <UserPermissionGate scopes={UserPermission.USER_CREATE}>
            <li className="tw-sticky tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white">
              <Link
                className="tw-flex tw-h-8 tw-items-center tw-font-medium tw-text-primary-100"
                to={OldApp.URL.SETTINGS.USERS}
                target="_blank"
              >
                {t('addClient')}
              </Link>
            </li>
          </UserPermissionGate>
        </ul>
      }
    >
      <div className="tw-pointer tw-mt-1 tw-inline-flex tw-items-center tw-text-sm">
        <Icon icon={faLock} className="tw-mr-1 tw-text-purple-100" size="sm" />
        <span>
          <Trans
            i18nKey="countOfClients"
            values={{ count: clients.length }}
            components={[
              <span className="tw-font-semibold tw-text-purple-100" />,
            ]}
          />
        </span>
      </div>
    </Tooltip>
  );
};

export default CommentsClientAssignedUsers;
